import React, { useEffect } from 'react';
import { useState } from 'react'
import SubmitPopup from '../Submitpopup/Submitpopup';
import axios from 'axios';
import { API_BASE_URL } from '@/config/serverApiConfig';
import { Modal, Spinner } from 'react-bootstrap';
import OtpInput from "react-otp-input";
import { useHistory } from 'react-router-dom';
// import SubmitPopup from "../Submitpopup/Submitpopup";

const Otp = (props) => {
  const history = useHistory();
  

  let USERID ='';
  if( props.user_id) { 
   USERID= props.user_id;
 }
 useEffect (() => {
   USERID= props.user_id;
 }, [])
  const [submitLoader, setSubmitLoader] = useState(false);
    const [smShow, setSmShow] = useState(false);
    const [resLogin1, setresLogin1] = useState({
        "status": "",
        "message": "",
        "token": "",
        "user": {
            "status": "",
            "role": "",
            "_id": "",
            "fname": "",
            "lname": "",
            "email": "",
            "city": "",
            "country": "",
            "phone": "",
            "reference": [],
            "created": "",
        }
    });

    function hideShow() {
      setSmShow(false)
      history.push('/login')
    }

    let [otp, setotp] = useState("");
    const [resData, setresData] = useState({
      message: "",
      status: "",
     
    });

    const otpHandler = (otp) => setotp(otp);
    async function OTP(event) {
      setSubmitLoader(true);
        event.preventDefault();
        axios.post(`${API_BASE_URL}user/regverifyotp`, {
            otp: otp,
            user_id: localStorage.getItem("user_id")
            
        })
            .then(function (response) {
              setSubmitLoader(false);
                setSmShow(true)
                setresData(response.data)
                setresLogin1(response.data)              
                localStorage.setItem('user_role', response.data.user.role)
                localStorage.setItem('user_fname', response.data.user.fname)
                localStorage.removeItem('user_id');           
            
            })
            .catch(function (error) {
                setSubmitLoader(false);
            
            });       
    }
    return (
        <>
        <SubmitPopup
        onClose={hideShow}
        show={smShow}
        title={resLogin1.message}
      />
             {/* <Modal
        size="sm"
        show={smShow}
        onHide={hideShow}
        aria-labelledby="example-modal-sizes-title-sm"
      >
      <Modal.Header closeButton className='border-0'></Modal.Header>
      <Modal.Body className='text-center py-5'>
        <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_113_322)">
            <path d="M42.2982 73.7798C61.5168 71.7083 75.4184 54.4594 73.3482 35.2533C71.278 16.0473 54.02 2.15707 34.8014 4.22862C15.5827 6.30017 1.68115 23.5491 3.75134 42.7551C5.82154 61.9611 23.0795 75.8514 42.2982 73.7798Z" fill="#9F7854" />
            <path d="M33.4835 57.1484L18.8401 42.1276L24.3222 36.7842L33.3144 46.0081L53.2186 24.3097L58.8613 29.4841L33.4835 57.1484Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_113_322">
              <rect width="70" height="70" fill="white" transform="translate(0 7.95245) rotate(-6.15208)" />
            </clipPath>
          </defs>
        </svg>
        <p className='pb-3 pt-3'>{
        // if resData.status is varified then show success message else show error message
        resData.status === "Verified" ? "OTP Verified Successfully" : resData.message}</p>
      </Modal.Body>
      
    </Modal> */}
            <section className={USERID != 0 ? "otp_sec" : "otp_sec  disable"}>
              <form className="otp-form" onSubmit={OTP}>
                    <div className='row'>
                        <div className='col-lg-3 d-flex align-items-center'>
                            <span className='otp_text'>Please Enter the OTP here: </span>
                        </div>

                        <div className='col-lg-9'>

                            <OtpInput 
                  value={otp}
                  onChange={otpHandler}
                  numInputs={6}
                  className="text-center form-control rounded p-0 border-0"/>

                        </div>
                    </div>
                                <div className="mt-5 col text-end mb-5"> <button type="submit" className="btn-full-color px-4 validate"> <Spinner
                        as="span"
                        animation={submitLoader ? "border" : ""}
                        size="sm"
                        role="status"
                        aria-hidden="false"
                      />
                      Validate</button> </div>
                </form>
                    <SubmitPopup />
            </section>
  
        </>
    )
}
export default Otp;
